import { render } from "./CheckboxAnswer.vue?vue&type=template&id=6ee65030"
import script from "./CheckboxAnswer.vue?vue&type=script&lang=js"
export * from "./CheckboxAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__